import { employeeConstants } from "./types";
import { toast } from "react-toastify";
import api from "../variables/api";

export const updateEmployee = ({ employeeID, payload }) => {
  const request = () => {
    return { type: employeeConstants.UPDATE_EMPLOYEE_REQUEST };
  };
  const success = () => {
    return { type: employeeConstants.UPDATE_EMPLOYEE_SUCCESS };
  };
  const failure = (error) => {
    return { type: employeeConstants.UPDATE_EMPLOYEE_FAILURE, error };
  };

  return async (dispatch) => {
    dispatch(request());

    try {
      await api.patch(`/employees/updateEmployee/${employeeID}`, payload, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });
      dispatch(success());
    } catch (error) {
      if (
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        dispatch(failure(`${error.response.data.message}`));
        toast.error(`${error.response.data.message}`);
      } else {
        dispatch(failure("Something went wrong"));
        toast.error("Something went wrong");
      }
    }
  };
};
